import { Location } from '@angular/common';
import { Component, Input, OnChanges, OnDestroy , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { State } from '@app/core/ngrx/reducers';
import { applicationSelectors } from '@app/core/ngrx/selectors';
import { PaymentService } from '@app/core/services/payment/payment.service';
import { ToolService } from '@app/core/services/tool/tool.service';
import { ImageSlideComponent } from '@app/shared/components/image-slide/image-slide.component';
// import { MobileCustomerActionsComponent } from '@app/shared/components/mobile-customer-actions/mobile-customer-actions.component';
import { canBook } from '@app/shared/utils';
import { ModalController, PopoverController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { Observable, Subscription, combineLatest, take } from 'rxjs';
import { ApplicationQuickActionsMobileComponent } from '../application-quick-actions-mobile/application-quick-actions-mobile.component';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ImgPipe } from '@app/shared/pipes/img/img.pipe';

@Component({
    selector: 'app-pending',
    templateUrl: './application-pending.component.html',
    styleUrls: ['./application-pending.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule, RouterModule, ImgPipe],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationPendingComponent implements OnChanges, OnDestroy {
    @Input() booking?: boolean;
    @Input() status: any;

    // checks to see if this user has already completed the authorize payment step of the booking process
    // didBook = this.status.application.states === 'Pending-Booked' ? true : false;
    // checks if the user is able to book
    canBook$: Observable<boolean> = this.store.select(applicationSelectors.getCanBooking);
    hasBook$: Observable<boolean> = this.store.select(applicationSelectors.hasReqBooking);

    showDynamicCopy = false;

    sliderOpts = {
        initialSlide: 0,
        speed: 400,
        scrollbar: true,
        slidesPerView: 1,
        centeredSlides: true,
        height: 192,
    };
    images = [];

    pending = {
        view: 'document',
    };

    showMeTheMoney = this.paymentService.getShowMeTheMoney();
    subscription: Subscription;
    newBooking = false;
    showPreApprovalDocument: boolean = true;
    isPreapprovalProgram: boolean = false;

    constructor(
        private popoverCtrl: PopoverController,
        private paymentService: PaymentService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
        private modalCtrl: ModalController,
        private store: Store<State>,
        public toolService: ToolService
    ) {}

    ngOnChanges() {
        this.isPreapprovalProgram = this.status.application.program.preapprovalrequired || this.status.application.states === 'Pre-Approved';
        //
        this.listener();
        //
        if (this.status.application.program.image.length > 0) {
            this.status.application.program.image.forEach((image) => {
                const arr = [];
                if (image.size === 'md') {
                    arr.push(image);
                    this.images.push(arr);
                }
            });
        }
        // check if preapproval documents exist

        // determine if the user can book and if they have already booked
        // if they have already booked, then we need to show the document view
        // if they have not booked and can book, then we need to show the program view
        // if they can book, and are a preapproval program, we need to show them the document view
        combineLatest(this.canBook$, this.hasBook$)
            .pipe(take(1))
            .subscribe(([canBook, hasBook]) => {
                if (canBook && this.isPreapprovalProgram) {
                    this.pending.view = 'document';
                    this.showPreApprovalDocument = true;
                } else if (canBook && !hasBook) {
                    // everything but pending booked
                    this.pending.view = 'program';
                    this.showPreApprovalDocument = false;
                } else {
                    // at this point is usually canBook was false bc its a last minute application or it is a Pending-Booked application with no preapproval
                    this.pending.view = 'document';
                    this.showPreApprovalDocument = true;
                }
            });
    }

    ngOnDestroy() {
        try {
            this.subscription.unsubscribe();
        } catch (e) {
            // ignore unsubscribe failure
        }
    }

    async moreActions(ev: any) {
        const popover = await this.popoverCtrl.create({
            component: ApplicationQuickActionsMobileComponent,
            mode: 'md',
            event: ev,
            backdropDismiss: true,
            animated: true,
            componentProps: {
                application: this.status.application,
            },
        });
        return popover.present();
    }

    openPreview = (img: any, i: number) => {
        this.modalCtrl
            .create({
                component: ImageSlideComponent,
                cssClass: 'image-slider-modal',
                componentProps: {
                    image: img,
                    index: i,
                    program: this.status.application.program,
                },
            })
            .then((modal) => {
                modal.present();
            });
    };

    // listen to see if user was directed to make a payment
    listener = () => {
        this.subscription = this.showMeTheMoney.subscribe((val: any) => {
            if (val) {
                try {
                    const url = this.router
                        .createUrlTree([`/application/${this.status.application.id}`], {
                            relativeTo: this.route,
                            queryParams: {
                                view: 'booking',
                            },
                        })
                        .toString();
                    this.location.replaceState(url);
                    const element = document.querySelector('#paymentScroll');
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                    });
                } catch (e) {
                    // application probably not set yet
                    // console.log(e);
                }
            } else {
                const url = this.router.createUrlTree([`/application/${this.status.application.id}`]).toString();
                this.location.replaceState(url);
            }
        });
    };

    segmentChanged(event: any) {
        this.pending.view = event.detail.value;
    }
}
